var render, staticRenderFns
import script from "./vc-bar-chart.vue?vue&type=script&lang=js&"
export * from "./vc-bar-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ba2f10')) {
      api.createRecord('21ba2f10', component.options)
    } else {
      api.reload('21ba2f10', component.options)
    }
    
  }
}
component.options.__file = "app/javascript/packs/components/charts/vc-bar-chart.vue"
export default component.exports